import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from "@angular/core";
import { FormBuilder, FormGroup, FormGroupDirective, NgForm, Validators } from "@angular/forms";
import { EventMessage } from "@azure/msal-browser";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { SingleEmailValidator } from "src/app/directives/multi-email.directive";
import { validarRut, VerificacionRutValidator } from "src/app/directives/verifica-rut.directive";
import { TipoProveedorCorreo } from "src/app/models/CasillaDteRecibidos/TipoProveedorCorreo";
import { ReceptorRequest } from "src/app/models/Receptor/ReceptorRequest";
import { PermissionService } from "src/app/services/permission.service";
import { TokenStorageService } from "src/app/services/token-storage.service";
import Swal from "sweetalert2";

@Component({
	selector: "app-tipo-correo-proveedor-entry",
	templateUrl: "./tipo-correo-proveedor-entry.component.html",
	styleUrls: ["./tipo-correo-proveedor-entry.component.scss"],
})
export class TipoCorreoProveedorEntryComponent implements OnInit {
	public tipoProveedorCorreoForm: FormGroup;
	private tipoProveedorCorreoObj: TipoProveedorCorreo = new TipoProveedorCorreo();
	public files: File[] = [];
	@Input() public TipoProveedorCorreoToEdit: TipoProveedorCorreo = undefined;
	@Input() public editMode: boolean = null;
	@Input() public detailMode: boolean = false;
	@Output() private sendCloseRequestEmitter: EventEmitter<any> = new EventEmitter<any>();
	@Output() private sendTipoProveedorCorreoRequest: EventEmitter<any> = new EventEmitter<any>();
	constructor(private formBuilder: FormBuilder, private tokenStorage: TokenStorageService, public permissions: PermissionService) {}

	ngOnInit(): void {
		this.cleanFiles();
		this.createForm();
		if (this.editMode) {
			this.settipoProveedorCorreoDataToForm(this.TipoProveedorCorreoToEdit);
		}
	}
	cleanFiles() {
		this.files = [];
	}
	createForm() {
		this.tipoProveedorCorreoForm = this.formBuilder.group({
			nombre: ["", Validators.required],
			configFile: [[Validators.required]],
		});
	}
	onSubmit() {
		if (this.tipoProveedorCorreoForm.valid) {
			this.getFormData();
			this.sendTipoProveedorCorreoRequest.emit(this.tipoProveedorCorreoObj);
		}
	}
	sendCloseRequest() {
		this.sendCloseRequestEmitter.emit();
	}

	getFormData() {
		this.tipoProveedorCorreoObj.nombre = this.tipoProveedorCorreoForm.controls.nombre.value;
		if (this.editMode) this.tipoProveedorCorreoObj.tipoProveedorCorreoId = this.TipoProveedorCorreoToEdit.tipoProveedorCorreoId;
		let reader = new FileReader();
		if (this.files[0] != null) {
			reader.readAsText(this.files[0]);
			reader.onload = (e) => {
				try {
					let file = JSON.parse(reader.result as string);
					this.tipoProveedorCorreoObj.jsonFormatoConfigFileEjemplo = file;
				} catch (error) {
					console.log(error);
					return;
				}
			};
		} else {
			Swal.fire({
				icon: "info",
				title: "Archivo de Configuración Vacio",
				text: "Seleccione un archivo de configuración válido",
			});
			return;
		}
	}

	settipoProveedorCorreoDataToForm(receivedtipoProveedorCorreo: TipoProveedorCorreo) {
		this.tipoProveedorCorreoForm.patchValue(receivedtipoProveedorCorreo);
		this.tipoProveedorCorreoForm.get("nombre").patchValue(receivedtipoProveedorCorreo.nombre);
	}
	onSelect(event) {
		if (event.rejectedFiles[0] || this.getName(event) != "json") {
			Swal.fire({
				icon: "error",
				title: "Error de Archivo",
				text: "El archivo ingresado no es de formato CSV, favor agregar un archivo con el formato correcto. Razón: " + event.rejectedFiles[0].reason == "size" ? "Tamaño" : "Tipo de archivo",
			});
		}

		this.files.push(...event.addedFiles);
		if (this.files.length > 1) {
			this.files.shift();
		}
		this.tipoProveedorCorreoForm.patchValue(this.files[0]);
	}
	onRemove(event) {
		this.files.splice(this.files.indexOf(event), 1);
	}

	getName(event): string {
		if (event.addedFiles) {
			return event.addedFiles[0].name.split(".").pop();
		} else if (event.rejectedFiles) {
			return event.rejectedFiles[0].name.split(".").pop();
		} else {
			return "";
		}
	}
}
